const baseApi = process.env.VUE_APP_BASE_API || '/app-api'

export default {
  baseApi
}
